<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <div class="flex justify-between">
    <drdp-title [title]="t('ratingViewSetup.assignment.title')"></drdp-title>
  </div>
  <drdp-container>
    <drdp-container additionClasses="min-h-[6rem] w-full" color="lightBlue">
      <form
        class="flex grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 p-5 gap-2 md:gap-3 flex-row content-center my-auto lg:items-end">
        <div class="col-span-1">
          <drdp-select-rating-period [initialRatingPeriodId]="selectedRatingPeriodId" (ratingPeriod)="handleRatingPeriod($event)" [agencyId]="agencyId"
            [clear]="clearDropdowns" [required]="true">
          </drdp-select-rating-period>
        </div>
        <div class="col-span-1">
          <drdp-select-site (site)="handleSites($event)" [agencyId]="agencyId" [multiSelect]="false"
            [multiSelectInitVals]="false" [clear]="clearDropdowns">
          </drdp-select-site>
        </div>

        <div class="col-span-1">
          <drdp-filter-select #classroomSelect [label]="t('common.classroom')" [options]="classroomList"
            [selectType]="selectType.Class" (onSelected)="handleClassroom($event)">
          </drdp-filter-select>
        </div>
        <div class="flex flex-row col-span-1 justify-evenly content-center mt-5 lg:justify-start md:col-span-2 ">
          <div class="mb-0 lg:mr-2">
            <drdp-btn (click)="search()">
              <span class="px-2">{{ t('common.search') }}</span>
            </drdp-btn>
          </div>
          <div>
            <drdp-btn color="outline" (click)="onClear()">{{ t('common.clear') }}</drdp-btn>
          </div>
        </div>
      </form>
    </drdp-container>
  </drdp-container>

  @for (result of results; track result) {
    <drdp-container additionClasses="mt-4">
      <div class="grid grid-cols-4">
        <div class="font-bold">{{ t('ratingViewSetup.assignment.selectAllFromSite') }}</div>
        <div class="font-bold">{{ t('sites.fields.siteName') }}</div>
        <div class="font-bold">{{ t('ratingViewSetup.customView.classrooms') }}</div>
        <div class="font-bold">{{ t('ratingViewSetup.assignment.viewSite') }}</div>
        <div>
          <mat-checkbox class="font-medium" [checked]="result.isSelected" [(ngModel)]="result.isSelected"
            [ngModelOptions]="{standalone: true}" (change)="toggleSite(result)">
          </mat-checkbox>
        </div>
        <!-- Server-supplied site name. -->
        <div>{{result.siteName}}</div>
        <div>{{result.classroomCount}}</div>
        <div><a class="font-bold text-blue-600 cursor-pointer"
          (click)="result.showClassrooms = !result.showClassrooms">{{ t('ratingViewSetup.assignment.openSiteList') }} <i
        [class]="result.showClassrooms ? 'uil uil-angle-right' : 'uil uil-angle-down'"></i></a></div>
      </div>
      @if (result.showClassrooms) {
        <hr class="my-4">
      }
      @if (result.showClassrooms) {
        <div class="grid grid-cols-5">
          <div></div>
          <div class="font-bold">{{ t('ratingViewSetup.assignment.selectEntireClassroom') }}</div>
          <div class="font-bold">{{ t('common.classroom') }}</div>
          <div class="font-bold">{{ t('common.ratingPeriod') }}</div>
          <div class="font-bold">{{ t('ratingViewSetup.assignment.viewStudents') }}</div>
          @for (classroom of result.classroomDetails; track classroom) {
            <div></div>
            <div class="text-center">
              <mat-checkbox class="font-medium" [checked]="classroom.isSelected" [(ngModel)]="classroom.isSelected"
                [ngModelOptions]="{standalone: true}" (change)="toggleClassroom(result, classroom)">
              </mat-checkbox>
            </div>
            <!-- Server-supplied classroom and rating period names. -->
            <div> {{classroom.classroomName }}</div>
            <div> {{classroom.ratingPeriodName }}</div>
            <div><a class="font-bold text-blue-600 cursor-pointer"
              (click)="classroom.showStudents = !classroom.showStudents">{{
                t('ratingViewSetup.assignment.openStudentList')
              }} <i [class]="classroom.showStudents ? 'uil uil-angle-right' : 'uil uil-angle-down'"></i></a>
              @if (classroom.showStudents) {
                <div class="student-box">
                  <!-- Server-supplied student name. -->
                  @for (student of classroom.students; track student) {
                    <div>
                      <mat-checkbox class="font-medium" [checked]="student.isSelected" [(ngModel)]="student.isSelected"
                        [ngModelOptions]="{standalone: true}" (change)="checkIsClassroomSelected(result, classroom, student)">
                        {{student.name}}
                      </mat-checkbox>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </drdp-container>
  }

  <div class="mt-4 mb-2 flex justify-end">
    <drdp-btn color="outline" (click)="cancel()">{{ t('common.cancel') }}</drdp-btn>
    @if (results.length > 0) {
      <drdp-btn (click)="submit()" class="ml-4"> {{ t('common.save') }} </drdp-btn>
    }
  </div>

</div>
</ng-container>
